/** Set to false to silence template-selection traces in the console. */
export const DEBUG_SIDEBAR_TEMPLATE_SELECTION = false;

const LOG_PREFIX = "[sidebar-template]";

export function logSidebarTemplate(event, data = {}) {
  if (!DEBUG_SIDEBAR_TEMPLATE_SELECTION) return;
  console.log(LOG_PREFIX, event, data);
}

export function previewText(text, maxLen = 120) {
  const s = String(text ?? "");
  if (s.length <= maxLen) return s;
  return `${s.slice(0, maxLen)}…`;
}
